var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefreshLine = function SvgRefreshLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.617 5.19A9 9 0 0 1 19.87 17.166L17 12h2.7A7.2 7.2 0 0 0 7.514 6.805zm11.766 13.62A9 9 0 0 1 5.13 6.834L8 12H5.3a7.2 7.2 0 0 0 12.186 5.195z"
  })));
};
export default SvgRefreshLine;